<div class="banner">
  <h1>{{ 'home.meet' | translate }} <span class="poster-font">Actabl</span></h1>
  <h5>
    {{ 'home.bannerSubtitle' | translate: ActablProductNames }}
  </h5>
</div>
